var render = function render(_c,_vm){return _c('div',{staticClass:"one-tooltip"},[_c('div',{staticClass:"one-tooltip__element"},[_vm._t("element"),_vm._v(" "),_c('div',{staticClass:"one-tooltip__text"},[_vm._t("text")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }